export default __webpack_public_path__ + "static/media/docs.bf605450.png";